var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[(_vm.sinalizacao)?_c('div',{directives:[{name:"tooltip",rawName:"v-tooltip",value:( 'Trilha Sinalizada' ),expression:" 'Trilha Sinalizada' "}]},[_c('i',{staticClass:"signe fa fa-map-signs",attrs:{"aria-hidden":"true"}})]):_vm._e()])
}
var staticRenderFns = []

export { render, staticRenderFns }